var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehaviourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3C14.552 3 15 3.448 15 4V9H20C20.552 9 21 9.448 21 10V20C21 20.552 20.552 21 20 21H10C9.448 21 9 20.552 9 20V15H4C3.448 15 3 14.552 3 14V4C3 3.448 3.448 3 4 3H14ZM13 5H5V13H13V5Z",
    fill: "#3B97FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviourIcon);
export default __webpack_public_path__ + "static/media/BehaviourIcon.dd3b818dce51756f6876e2cb150ea9d1.svg";
export { ForwardRef as ReactComponent };